var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "login",
    width: 24,
    height: 24,
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M15.1111 7.11111C15.1111 5.39289 13.7182 4 12 4C10.2818 4 8.88889 5.39289 8.88889 7.11111C8.88889 8.82933 10.2818 10.2222 12 10.2222C13.7182 10.2222 15.1111 8.82933 15.1111 7.11111Z",
    fillRule: "nonzero",
    stroke: "rgb(0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M4 20L20 20L20 19.4667C20 17.4754 20 16.4797 19.6125 15.7191C19.2716 15.0501 18.7276 14.5062 18.0586 14.1653C17.298 13.7778 16.3024 13.7778 14.3111 13.7778L9.68889 13.7778C7.6976 13.7778 6.70196 13.7778 5.94138 14.1653C5.27235 14.5062 4.72841 15.0501 4.38753 15.7191C4 16.4797 4 17.4754 4 19.4667L4 20Z",
    fillRule: "nonzero",
    stroke: "rgb(0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.d3719bd19bd4e3db1c74255f2dbafb86.svg";
export { ForwardRef as ReactComponent };